import type { Review } from './content';
import { REVIEW_ROWS, REVIEW_SOURCES, REVIEW_STARS_IMAGE } from './content';
import { sectionHeading, sectionShell } from './landing.css';
import * as styles from './Reviews.css';

const ReviewCard = ({ review }: { review: Review }) => {
  const source = REVIEW_SOURCES[review.source];

  return (
    <li className={styles.card}>
      <div className={styles.cardTop}>
        <img
          className={styles.stars}
          src={REVIEW_STARS_IMAGE.src}
          width={REVIEW_STARS_IMAGE.width}
          height={REVIEW_STARS_IMAGE.height}
          alt="5 out of 5 stars"
        />
        <p className={styles.body}>{review.body}</p>
      </div>
      <div className={styles.cardBottom}>
        <p className={styles.name}>{review.name}</p>
        <a
          className={styles.sourceLink}
          href={review.href}
          target="_blank"
          rel="noreferrer"
          aria-label={`Read Blinq reviews on ${source.label}`}
        >
          <img className={styles.sourceIcon} src={source.icon} alt="" />
        </a>
      </div>
    </li>
  );
};

const ReviewRow = ({ reviews, offset }: { reviews: readonly Review[]; offset: boolean }) => (
  <div className={styles.marquee}>
    <div className={`${styles.track} ${offset ? styles.trackOffset : ''}`}>
      <ul className={styles.list}>
        {reviews.map((review) => (
          <ReviewCard key={review.name} review={review} />
        ))}
      </ul>
      <ul className={styles.list} aria-hidden inert>
        {reviews.map((review) => (
          <ReviewCard key={review.name} review={review} />
        ))}
      </ul>
    </div>
  </div>
);

export const Reviews = () => (
  <section className={`${sectionShell} ${styles.section}`}>
    <h2 className={`${sectionHeading} ${styles.heading}`}>
      Loved by professional
      <br />
      optimists globally
    </h2>
    <div className={styles.rows}>
      {REVIEW_ROWS.map((reviews, index) => (
        <ReviewRow key={reviews[0]?.name} reviews={reviews} offset={index % 2 === 1} />
      ))}
    </div>
  </section>
);
